import { render, staticRenderFns } from "./imgPreview.vue?vue&type=template&id=2553e47d&scoped=true"
import script from "./imgPreview.vue?vue&type=script&lang=js"
export * from "./imgPreview.vue?vue&type=script&lang=js"
import style0 from "./imgPreview.vue?vue&type=style&index=0&id=2553e47d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2553e47d",
  null
  
)

export default component.exports